import { KeycloakContext } from '@laborability/components';
import { useContext, useEffect } from 'react';

export default function Logout() {
  const { keycloak } = useContext(KeycloakContext);

  useEffect(() => {
    keycloak?.logout();
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('idToken');
    sessionStorage.removeItem('login');
    keycloak?.login();
  }, []);

  return null;
}
